// src/api/dashboard.js
// API utility for Dashboard summary data

export async function getDashboardSummary() {
  const response = await fetch("/dashboard/summary-aggregate");
  if (!response.ok) {
    throw new Error("Failed to fetch dashboard aggregate summary");
  }

  const payload = await response.json();
  const portfolioPayload = payload?.portfolio ?? null;
  const readinessPayload = payload?.readiness ?? null;
  const readinessTrendPayload = payload?.readiness_trend ?? null;
  const alpacaPayload = payload?.alpaca ?? null;
  const capitalPayload = payload?.capital ?? null;
  const providersPayload = payload?.providers ?? null;

  const analytics =
    portfolioPayload && portfolioPayload.status === "error"
      ? null
      : portfolioPayload?.analytics ?? portfolioPayload ?? null;

  const readiness =
    readinessPayload && readinessPayload.status === "error"
      ? null
      : readinessPayload?.readiness ?? readinessPayload ?? null;

  const readinessTrend =
    readinessTrendPayload && readinessTrendPayload.status === "error"
      ? null
      : readinessTrendPayload?.trend ?? readinessTrendPayload ?? null;

  const health =
    providersPayload && providersPayload.status === "error"
      ? null
      : providersPayload?.providers ?? providersPayload ?? null;

  return {
    analytics,
    readiness,
    readinessLatest: payload?.readiness_latest ?? null,
    readinessTrend,
    readinessActionLatest: payload?.readiness_action_latest ?? null,
    alpaca: alpacaPayload,
    capital: capitalPayload,
    health,
    anomaly: payload?.anomaly ?? null,
    screener: payload?.screener ?? null,
    autonomous: payload?.autonomous ?? null,
  };
}
